// import { getIp, checkInnerIpParag, checkGoogleIp } from '@/static/whiteIpList'
export default function ({ app, redirect, route }) {
  // 1. 处理域名重定向 2. ip隔离 国内外网站跳转
  // 当前函数在服务端渲染的时候，刷新的时候只有一次，在router的进程中是不进行操作
  // const requestIp = () => {
  //   // 获取用户ip
  //   // if (requestHost(req)) {
  //   //   return redirect('http://fjdms_dev.fjdynamics.com')
  //   // }
  //   const userIp = getIp(req)
  //   console.log(121313123, userIp)
  //   //  非内网，非googleIp
  //   if (!checkInnerIpParag(userIp) && !checkGoogleIp(userIp)) {
  //     console.log(121313123, userIp)
  //     // 存储ip地址
  //     store.commit('storeUserIp', userIp)
  //   }
  // }
  // process.server && requestIp()
  // 处理路径函数 路径参数处理
  const urlRules = () => {
    // 第一条规则en前缀
    const isEnPrefix = route.fullPath.startsWith('/en')
    // 第二条规则带有html
    const isWithHtml = route.fullPath.includes('.html')
    // 第三条规则持续待参数
    const paramsIndex = route.fullPath.indexOf('?')
    // 存储参数到cookie中
    const urlCookieTail = (isHas) => {
      // 存在
      if (isHas) {
        const urltail = route.fullPath.slice(paramsIndex)
        // 参数存在只暂存 不做处理
        app.$cookies.set('tail', urltail)
      }
    }
    const urlWithHtml = (isHtml) => {
      if (isHtml) {
        route.fullPath = route.fullPath.replace(/\.html/i, '')
      }
    }

    // const urlWithSlash = (url) => {
    //   return url[url.length - 1] === '/'
    // }
    const urlWithEnIndex = () => {
      // /en/xxxxen 剩余 /xxxxen
      const isEnPrefix = route.fullPath.startsWith('/en')
      if (isEnPrefix) {
        // 带en
        route.fullPath = route.fullPath.slice(3)
      }
      const isIndexPrefix = route.fullPath.startsWith('/index')
      if (isIndexPrefix) {
        route.fullPath = route.fullPath.slice(6)
      }
      // 处理尾部是/的路径
      // const isWithSlash = urlWithSlash(route.fullPath)
      // if (route.fullPath && isWithSlash) {
      //   route.fullPath = route.fullPath.slice(0, route.fullPath.length - 1)
      // }
      if (!route.fullPath) {
        route.fullPath = '/'
      }
      // 尾部是index 或者尾部是/的
      return isIndexPrefix
    }

    // 判断逻辑 带en前缀 (注意只关心前缀，后续路径中带en不处理)
    if (isEnPrefix) {
      urlWithHtml(isWithHtml) // html处理
      urlWithEnIndex() // 处理en/index
      urlCookieTail(paramsIndex > -1) // 参数处理
      redirect(route.fullPath)
    } else if (isWithHtml) {
      // 不带en前缀
      // 这里面有一种正常的情况是不做跳转 (不带en 不带html)
      urlWithHtml(isWithHtml) // html处理
      urlWithEnIndex() // 处理/index
      urlCookieTail(paramsIndex > -1) // 参数处理
      redirect(route.fullPath)
    } else if (paramsIndex > -1) {
      // 处理参数
      urlCookieTail(paramsIndex > -1) // 参数处理
    } else {
      // 正常且无参数就就加上存在的参数
      // const cookietail = app.$cookies.get('tail')
      // 参数存在就加上
      // if (cookietail) {
      //   route.fullPath += cookietail
      //   // url变化了进行跳转
      //   redirect(route.fullPath)
      // } else if (urlWithEnIndex()) {
      //   console.log(route.fullPath, 12123123)
      // index的情况不带html
      // redirect(route.fullPath)
      // }
    }
  }
  // 输出最终的url
  urlRules()
}
